import React, { useEffect, useState } from 'react';
import MainLayout from '../components/MainLayout';
import { Input, message as toastMessage, Typography } from "antd";
import ThemedButton from '../components/ThemedButton';
import cmkLogo from '../assets/CMK-logo.png';
import ContactInfoItem from '../components/ContactInfoItem';
import { ReactComponent as MapPin } from '../assets/pin.svg';
import { ReactComponent as Phone } from '../assets/phone.svg';
import { ReactComponent as Email } from '../assets/email.svg';
import { waspContactInfo } from '../util/contactInfo';
import requests from '../api/requests';
import { contactEndpoint } from '../api/endpoints';


const validateEmail = email => email && /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(email)

const FormItem = ({ value = '', onChange, label, textArea, error }) => (
  <div className={`form-group ${error && 'error'}`}>
    <div className="form-item-title">
      {label}
    </div>
    {textArea && (
      <div className={`form-item-input text-area {error && 'error'}`}>
        <Input.TextArea value={value} allowClear onChange={e => onChange(e.target.value)} autoSize={{ minRows: 4 }} />
      </div>
    )}
    {!textArea && (
      <div className={`form-item-input ${error && 'error'}`}>
        <Input value={value} onChange={e => onChange(e.target.value)} />
      </div>
    )}
    <div className="error-message">
      {error}
    </div>
  </div>
)

const ContactPage = () => {

  const [ name, setName ] = useState(null);
  const [ email, setEmail ] = useState(null);
  const [ message, setMessage ] = useState(null);
  const [ loading, setLoading ] = useState(false);
  const [ errors, setErrors ] = useState({
    name: null,
    email: null,
    message: null
  })

  const submitDisabled = !name || !email || !message || loading || Object.values(errors).some(er => er?.length)

  const resetForm = () => {
    setName(null);
    setEmail(null);
    setMessage(null);
    setErrors({
      name: null,
      email: null,
      message: null
    })
  }

  useEffect(() => {
    setErrors(err => ({
      ...err,
      name: name === null || name.length ? null : 'Required field'
    }))
  }, [ name ])

  useEffect(() => {
    setErrors(err => ({
      ...err,
      message: message === null || message.length ? null : 'Required field'
    }))
  }, [ message ])

  useEffect(() => {
    let error = null;
    if (typeof email === 'string') {
      if (!email.length) {
        error = 'Required field';
      }
      else if (!validateEmail(email)) {
        error = 'Not a valid email'
      }
    }
    setErrors(err => ({
      ...err,
      email: error
    }))
  }, [ email ])

  const submitMessage = () => {
    setLoading(true);
    requests.post(contactEndpoint(), {
      mail: email,
      message,
      name
    })
      .then((resp) => {
        if (resp?.data?.success) {
          toastMessage.success('Your message received successfully!', 4);
          resetForm();
        }
        else {
          toastMessage.error('Something went wrong :/', 4)
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <MainLayout loading={loading}>
      <div className="contact-us-page">
        <div className="top">
          <div className="content-wrapper">
            <div className="contact-items">
              <div>
                <Typography.Title level={2}>
                  CONTACT US
                </Typography.Title>
              </div>
              <ContactInfoItem
                icon={Phone}
                title="Call Us"
                text={waspContactInfo.tel}
              />
              <ContactInfoItem
                icon={Email}
                title="Write Us"
                text={waspContactInfo.email}
              />
              <ContactInfoItem
                icon={MapPin}
                title="Visit Us"
                text={waspContactInfo.address.multiLine}
              />
            </div>
            <div className="form-section">
              <FormItem value={name} error={errors.name} label="Your name *" onChange={setName} />
              <FormItem value={email} error={errors.email} label="Your mail *" onChange={setEmail} />
              <FormItem value={message} error={errors.message} textArea label="Your message *" onChange={setMessage} />
              <div className="button-container">
                <ThemedButton reversed disabled={submitDisabled} onClick={submitMessage}>Submit</ThemedButton>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom">
          <div className="info">
            <div>Hasselt University</div>
            <div>{waspContactInfo.address.multiLine[0]}</div>
            <div>{waspContactInfo.address.multiLine[1]}</div>
            <div>Tel: {waspContactInfo.tel}</div>
            <div>Fax: {waspContactInfo.fax}</div>
          </div>
          <div>
            <img src={cmkLogo} alt={cmkLogo} />
          </div>
        </div>
      </div>
    </MainLayout>
  )
};

export default ContactPage;
